import { createFileRoute } from "@tanstack/react-router";
import EgyptOutsourcingCosts from "@/pages/blog/EgyptOutsourcingCosts";

export const Route = createFileRoute("/en/blog/egypt-outsourcing-costs")({
  component: EgyptOutsourcingCosts,
});
